import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const baseSx = {
  height: 32,
  borderRadius: '128px',
  fontWeight: 500,
  fontSize: '16px',
  textTransform: 'capitalize',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  userSelect: 'none',
  whiteSpace: 'nowrap',
};

export const ChipRoot = styled(Box, {
  shouldForwardProp: prop => prop !== 'selected',
})(({ theme, selected }) => ({
  ...baseSx,
  gap: theme.spacing(0.5),
  ...(selected
    ? {
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        backgroundColor: theme.palette.successGreen.white80,
        border: `1px solid ${theme.palette.successGreen.black20}`,
        color: theme.palette.successGreen.black80,
      }
    : {
        paddingLeft: theme.spacing(2.75),
        paddingRight: theme.spacing(2.75),
        backgroundColor: theme.palette.stoneGrey.white60,
        border: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.primary,
      }),
}));
